module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre7 sgc-15 sgc-49 sigilNotInTOC",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "calibre9"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter01"
    }
  }, [_vm._v("Curtain Raiser")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter02"
    }
  }, [_vm._v("Dramatis Personae")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rehearsals")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Entr’acte (Saturday Morning, Causton High Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Night")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enter the Broker’s Men")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exit, Pursued by a Bear")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Opening, Another Show")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read the Prologue and first chapter of "), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Death in Disguise")]), _vm._v(", the next title in the “Inspector Barnaby” series!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Deaths")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262d6358","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Toc.vue
// module id = 63
// module chunks = 0